// extracted by mini-css-extract-plugin
export default {"item":"CartItem_item__m-ebF","imgDiv":"CartItem_imgDiv__0P5cU","infos":"CartItem_infos__UaFxX","price":"CartItem_price__abLEP","btn":"CartItem_btn__q5E69"};